import React from 'react'
import MaterialSymbol from '../material-symbol'

const North = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="north" {...props} />
))

North.displayName = 'North'

export default North
